export default {
  props: {
    typeaheadItemKey: {
      type: String,
      default: 'value'
    },

    typeahead: {
      default () {
        return async () => {
        }
      }
    },

    typeaheadData: {
      type: Array,
      required: false,
      default () {
        return []
      }
    },

    selectTypeahead: {
      default () {
        return async () => {
        }
      }
    },

    typeaheadLimit: {
      type: Number,
      default: Number(process.env.VUE_APP_TYPEAHEAD_LIMIT)
    }
  },

  watch: {
    inputValue: async function (query) {
      this.data = await this.typeahead(query)
    }
  }
}
